export default [

	{
		title: 'Your Details',
		header: '',
		component: () => import( /* webpackChunkName: "stages" */ '../components/stages/YourDetails' ),
		nextButtonLabel: 'Continue to Review Your Details',
	},
	{
		title: 'Review Your Details',
		header: 'Review Your Details',
		subHeader: 'A summary of your answers is provided below. Please review to confirm these appear correct and/or edit if necessary.',
		showFindOutMore: true,
		component: () => import( /* webpackChunkName: "stages" */ '../components/stages/ReviewDetails' ),
		nextButtonLabel: 'Get Results',
		caption: 'By clicking this button you will have submitted your details to us and we will tell you what to do next on the final screen.',
	},
	{
		title: 'All Done!',
		header: '',
		showFindOutMore: true,
		component: () => import( /* webpackChunkName: "stages" */ '../components/stages/Complete' ),
		nextButtonLabel: 'Start Again',
		caption: ' ',
	},

];
